<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i>Magic Words</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-magic-word' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <magic-words-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="magicWords" v-bind:actions="true"></magic-words-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'
import MagicWordsTable from "./Table";

export default {
  name: 'magic-words-view',
  components: {MagicWordsTable},
  data() {
        return {
            magicWords: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getMagicWords();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getMagicWords();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getMagicWords();
    },
    onPageChanged(page){
        this.page = page;        
        this.getMagicWords();
    },
      getMagicWords(){
        let  data = {
            page: this.page,
            q: this.q,
            orderBy:this.orderBy
        };
        this.magicWordRepo.paginate(data).then(response => {
            this.magicWords = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/magic-words/View.vue